import CircularMenu from '@components/CircularMenu/CircularMenu';
import ContentRing from '@components/ContentRing/ContentRing';
import SpaceBackground from '@components/SpaceBackground/SpaceBackground';

import { useApp } from '../context/AppContext';

import styles from './HomePage.module.css';

/**
 * HomePage Component
 *
 * Main portfolio page featuring circular UI with space theme
 * Displays:
 * - SpaceBackground: Animated star field
 * - CircularMenu: Center menu with artist photo and navigation items
 * - ContentRing: Dynamic content area based on menu selection
 */
const HomePage = (): JSX.Element => {
  const { content } = useApp();
  const isBlogPage = content?.type === 'blog';

  return (
    <div className={`${styles.homePage} ${isBlogPage ? styles.scrollable : ''}`}>
      <SpaceBackground />
      <CircularMenu />
      <ContentRing />
    </div>
  );
};

export default HomePage;
